<template>
  <v-container>
    <div class="flex-column d-flex" :style="{ gap: '10px' }">
      <div>
        <v-text-field outlined hide-details="auto" label="Email" type="email" :value="inputs.email"
          :error-messages="errors.email" @change="v => setInputs('email', v)" />
      </div>
      <div>
        <v-text-field outlined hide-details="auto" label="Password" type="password" :value="inputs.password"
          :error-messages="errors.password" @change="v => setInputs('password', v)" />
      </div>
      <div>
        <v-btn color="success" dark block @click="submit" :loading="loading">
          <span>Save</span>
        </v-btn>
      </div>
      <div>
        <v-btn color="error" dark block @click="close" :loading="loading">
          <span>Cancel</span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import { isAxiosError } from 'axios'
import { authAxios } from '../../../../../extra-functions/axios.extra'
import { ConfirmPopup, ErrorPopup, LoadingPopup, SuccessPopup } from '../../../../../lib/utils'

export default {
  name: 'CreateConsumerUser',
  data() {
    return {
      consumerId: null,
      inputs: {
        email: null,
        password: null,
      },
      errors: {},
      loading: false,
    }
  },
  methods: {
    async submit() {
      try {
        if (!this.consumerId) throw new Error('consumer is not selected')
        const { isConfirmed } = await ConfirmPopup.fire('Confirm', 'Are you sure you want to create this user?')
        if (!isConfirmed) return

        LoadingPopup.fire('Saving', 'Saving user on the server...')
        const { data } = await authAxios().post(`/v2/consumer-users/${this.consumerId}`, {
          ...this.inputs,
        })

        SuccessPopup.fire('Success', data?.message || 'User successfully created')
        this.$emit('success')
        this.close()
      } catch (e) {
        LoadingPopup.close()
        if (isAxiosError(e) && e.status === 422) {
          const { errors = {} } = e.response.data ?? {}
          this.errors = errors
          return
        }
        console.error(e)
        ErrorPopup.fire('Oops', 'Something went wrong')
      }
    },
    setConsumerId(consumerId) {
      this.consumerId = consumerId
    },
    setInputs(key, value) {
      this.inputs = {
        ...this.inputs,
        [key]: value,
      }
    },
    close() {
      this.$emit('close')
      this.inputs.email = null
      this.inputs.password = null
    },
  },
}
</script>